// // import React, { useState, useEffect } from "react";
// // import { withRouter, Link } from "react-router-dom";
// // import { connect, useSelector } from "react-redux";
// // import PriceTag from "./PricePlans/PriceTag";
// // import ThreeBtn from "./PricePlans/ThreeBtn";

// // import {
// //   Card,
// //   CardContent,
// //   Typography,
// //   Box,
// //   Button,
// //   Zoom,
// // } from "@mui/material";
// // import InfoIcon from "@mui/icons-material/Info";
// // import userService from "../services/userService";

// // function Subscription({
// //   price_detail,
// //   planName,
// //   planList,
// //   btn_list,
// //   plan_mode,
// //   hide,
// //   currentUser,
// //   plan_id,
// //   defaultPlan,
// // }) {
// //   const [planPeriod, setplanPeriod] = useState(null);
// //   const userDetails = useSelector((user) => user);
// //   const [currentPlan, setCurrentPlan] = useState();
// //   const [currentplancheck, setCurrentplancheck] = useState(false);

// //   useEffect(() => {
// //     console.log("planName_", userDetails, planName);
// //     if (planPeriod) {
// //       console.log(planPeriod, "planPeriod", planName);
// //     }
// //   }, [planPeriod]);

// //   // useEffect(() => {
// //   //   if (userDetails) {
// //   //     async function fetchPlan() {
// //   //       const email = userDetails?.user?.currentUser?.email;
// //   //       const res = await userService.getUserProfile(email);
// //   //       const userData = res.data.user;
// //   //       setCurrentPlan(userData.plan.name);
// //   //     }
// //   //     fetchPlan();
// //   //   }
// //   // }, [currentplancheck]);

// //   useEffect(() => {
// //     if (userDetails?.user?.currentUser?.email) {
// //       async function fetchPlan() {
// //         try {
// //           const email = userDetails.user.currentUser.email;
// //           const res = await userService.getUserProfile(email);
// //           const userData = res.data.user;

// //           setCurrentPlan(userData.plan.name);

// //           // ✅ IMPORTANT: also update Redux so whole app knows
// //           if (res.data.user) {
// //             // if you have setCurrentUser in props
// //             // props.setCurrentUser(res.data.user);
// //           }
// //         } catch (err) {
// //           console.log("Error fetching updated plan", err);
// //         }
// //       }

// //       fetchPlan();
// //     }
// //   }, [currentplancheck, userDetails?.user?.currentUser?.email]);

// //   const isCurrentPlan =
// //     currentPlan === planName && !currentUser?.isAdmin && hide !== true;

// //   return (
// //     <Zoom in={true} style={{ transitionDelay: "100ms" }}>
// //       <Card
// //         elevation={isCurrentPlan ? 12 : 4}
// //         sx={{
// //           height: "100%",
// //           width: "100%",
// //           display: "flex",
// //           flexDirection: "column",
// //           borderRadius: 4,
// //           transition: "all 0.3s ease-in-out",
// //           position: "relative",
// //           // border: isCurrentPlan
// //           //   ? "4px solid #667eea"
// //           //   : "1px solid rgba(0,0,0,0.12)",
// //           background: isCurrentPlan
// //             ? "linear-gradient(145deg, #1976d2 0%, #e8eeff 100%);"
// //             : "white",
// //           transform: isCurrentPlan ? "scale(1.05)" : "scale(1)",
// //           "&:hover": {
// //             transform: isCurrentPlan
// //               ? "scale(1.05) translateY(-8px)"
// //               : "translateY(-8px)",
// //             boxShadow: isCurrentPlan
// //               ? "0 20px 60px rgba(102, 126, 234, 0.5)"
// //               : "0 12px 40px rgba(102, 126, 234, 0.3)",
// //           },
// //         }}
// //       >
// //         {isCurrentPlan && (
// //           <Box
// //             sx={{
// //               position: "absolute",
// //               top: 26,
// //               right: -33,
// //               transform: "rotate(45deg)",
// //               bgcolor: "#ee942dff",
// //               color: "white",
// //               px: 6,
// //               py: 0.7,
// //               fontSize: "12px",
// //               fontWeight: 700,
// //               zIndex: 10,
// //               boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
// //             }}
// //           >
// //             CURRENT
// //           </Box>
// //         )}

// //         <CardContent
// //           sx={{
// //             p: 3,
// //             display: "flex",
// //             flexDirection: "column",
// //             height: "100%",
// //           }}
// //         >
// //           {/* Plan Name */}
// //           <Typography
// //             variant="h5"
// //             sx={{
// //               textAlign: "center",
// //               fontWeight: 700,
// //               mb: 2,
// //               color: isCurrentPlan ? "white" : "#1a1a2e",
// //             }}
// //           >
// //             {planName}
// //           </Typography>

// //           {/* Period Selector */}
// //           {!defaultPlan && (
// //             <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
// //               <ThreeBtn
// //                 btn_list={btn_list}
// //                 planPeriod={(period) => setplanPeriod(period)}
// //                 pricebox={true}
// //               />
// //             </Box>
// //           )}

// //           {/* Price */}
// //           <Box sx={{ flexGrow: 1 }}>
// //             <PriceTag
// //               price_detail={price_detail}
// //               planPeriod={planPeriod}
// //               planName={planName}
// //               planList={planList}
// //               plan_mode={plan_mode}
// //               bg_color={"bg-white"}
// //               price_size={"50px"}
// //               hide={hide}
// //               plan_id={plan_id}
// //               defaultPlan={defaultPlan}
// //               isCurrentPlan={isCurrentPlan}
// //               setCurrentPlan={setCurrentPlan}
// //               setCurrentplancheck={setCurrentplancheck}
// //             />
// //           </Box>

// //           {/* Learn More */}
// //           <Button
// //             component={Link}
// //             to={{ pathname: hide ? "/homepricedetails" : "/pricedetails" }}
// //             variant="outlined"
// //             fullWidth
// //             startIcon={<InfoIcon />}
// //             sx={{
// //               mt: 2,
// //               borderRadius: 3,
// //               fontWeight: 600,
// //               borderColor: isCurrentPlan ? "#667eea" : "primary.main",
// //               color: isCurrentPlan ? "#667eea" : "primary.main",
// //             }}
// //           >
// //             Learn more
// //           </Button>
// //         </CardContent>
// //       </Card>
// //     </Zoom>
// //   );
// // }

// // const mapStateToProps = (state) => ({
// //   currentUser: state.user.currentUser,
// // });

// // export default connect(mapStateToProps)(withRouter(Subscription));



// import React, { useState, useEffect } from "react";
// import { withRouter, Link } from "react-router-dom";
// import { connect, useSelector } from "react-redux";
// import PriceTag from "./PricePlans/PriceTag";
// import ThreeBtn from "./PricePlans/ThreeBtn";

// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Button,
//   Zoom,
//   Chip,
//   Divider,
//   alpha,
//   useTheme
// } from "@mui/material";
// import InfoIcon from "@mui/icons-material/Info";
// import StarIcon from "@mui/icons-material/Star";
// import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
// import userService from "../services/userService";

// function Subscription({
//   price_detail,
//   planName,
//   planList,
//   btn_list,
//   plan_mode,
//   hide,
//   currentUser,
//   plan_id,
//   defaultPlan,
//   isMostPopular,
//   index
// }) {
//   const [planPeriod, setplanPeriod] = useState(null);
//   const userDetails = useSelector((user) => user);
//   const [currentPlan, setCurrentPlan] = useState();
//   const [currentplancheck, setCurrentplancheck] = useState(false);
//   const theme = useTheme();

//   useEffect(() => {
//     if (planPeriod) {
//       console.log(planPeriod, "planPeriod", planName);
//     }
//   }, [planPeriod]);

//   useEffect(() => {
//     if (userDetails?.user?.currentUser?.email) {
//       async function fetchPlan() {
//         try {
//           const email = userDetails.user.currentUser.email;
//           const res = await userService.getUserProfile(email);
//           const userData = res.data.user;
//           setCurrentPlan(userData.plan.name);
//         } catch (err) {
//           console.log("Error fetching updated plan", err);
//         }
//       }
//       fetchPlan();
//     }
//   }, [currentplancheck, userDetails?.user?.currentUser?.email]);

//   const isCurrentPlan = currentPlan === planName && !currentUser?.isAdmin && hide !== true;

//   const getPlanColor = () => {
//     if (isCurrentPlan) return theme.palette.success.main;
//     if (isMostPopular) return theme.palette.warning.main;
//     return theme.palette.primary.main;
//   };

//   return (
//     <Zoom in={true} style={{ transitionDelay: `${100 + (index || 0) * 50}ms` }}>
//       <Card
//         elevation={isCurrentPlan ? 12 : 4}
//         sx={{
//           height: "100%",
//           width: "100%",
//           display: "flex",
//           flexDirection: "column",
//           borderRadius: 4,
//           transition: "all 0.3s ease-in-out",
//           position: "relative",
//           overflow: "visible",
//           background: isCurrentPlan 
//             ? `linear-gradient(135deg, ${alpha(theme.palette.success.light, 0.1)} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`
//             : "white",
//           border: isCurrentPlan
//             ? `2px solid ${theme.palette.success.main}`
//             : isMostPopular
//             ? `1px solid ${alpha(theme.palette.warning.main, 0.5)}`
//             : `1px solid ${alpha(theme.palette.divider, 0.5)}`,
//           transform: "scale(1)",
//           "&:hover": {
//             transform: "translateY(-12px)",
//             boxShadow: isCurrentPlan
//               ? `0 20px 40px ${alpha(theme.palette.success.main, 0.3)}`
//               : `0 20px 40px ${alpha(theme.palette.primary.main, 0.2)}`,
//           },
//         }}
//       >
//         {/* Most Popular Badge */}
//         {isMostPopular && !defaultPlan && !isCurrentPlan && (
//           <Box
//             sx={{
//               position: "absolute",
//               top: -12,
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 10,
//             }}
//           >
//             <Chip
//               icon={<StarIcon sx={{ fontSize: 16 }} />}
//               label="MOST POPULAR"
//               sx={{
//                 backgroundColor: theme.palette.warning.main,
//                 color: "white",
//                 fontWeight: 700,
//                 fontSize: "12px",
//                 px: 1,
//                 py: 0.5,
//                 "& .MuiChip-icon": { color: "white" }
//               }}
//             />
//           </Box>
//         )}

//         {/* Current Plan Badge */}
//         {isCurrentPlan && (
//           <Box
//             sx={{
//               position: "absolute",
//               top: 20,
//               right: -30,
//               transform: "rotate(45deg)",
//               backgroundColor: theme.palette.success.main,
//               color: "white",
//               px: 6,
//               py: 0.7,
//               fontSize: "12px",
//               fontWeight: 700,
//               zIndex: 10,
//               boxShadow: `0 4px 10px ${alpha(theme.palette.success.main, 0.5)}`,
//             }}
//           >
//             CURRENT
//           </Box>
//         )}

//         <CardContent
//           sx={{
//             p: 3,
//             display: "flex",
//             flexDirection: "column",
//             height: "100%",
//           }}
//         >
//           {/* Plan Name with Icon */}
//           <Box sx={{ textAlign: "center", mb: 2 }}>
//             <Box
//               sx={{
//                 width: 60,
//                 height: 60,
//                 borderRadius: "50%",
//                 background: `linear-gradient(135deg, ${getPlanColor()}, ${alpha(getPlanColor(), 0.6)})`,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 mx: "auto",
//                 mb: 2,
//               }}
//             >
//               <EmojiEventsIcon sx={{ color: "white", fontSize: 30 }} />
//             </Box>
//             <Typography
//               variant="h5"
//               sx={{
//                 fontWeight: 800,
//                 background: isCurrentPlan
//                   ? theme.palette.success.main
//                   : isMostPopular
//                   ? `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.warning.dark})`
//                   : `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 color: isCurrentPlan || isMostPopular ? "transparent" : "inherit",
//                 WebkitTextFillColor: isCurrentPlan || isMostPopular ? "transparent" : "inherit",
//               }}
//             >
//               {planName}
//             </Typography>
//           </Box>

//           {/* Plan Description */}
//           <Typography
//             variant="body2"
//             sx={{
//               textAlign: "center",
//               color: "text.secondary",
//               mb: 3,
//               pb: 2,
//               borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`
//             }}
//           >
//             {planName === "Basic Plan" && "Perfect for individuals starting out"}
//             {planName === "Professional Plan" && "Best for growing professionals"}
//             {planName === "Premium Plan" && "Ideal for teams and businesses"}
//             {planName === "Enterprise Plan" && "Custom solutions for large organizations"}
//             {!["Basic Plan", "Professional Plan", "Premium Plan", "Enterprise Plan"].includes(planName) && "Choose the plan that fits your needs"}
//           </Typography>

//           {/* Period Selector */}
//           {!defaultPlan && (
//             <Box sx={{ mb: 3, display: "flex", justifyContent: "center" }}>
//               <ThreeBtn
//                 btn_list={btn_list}
//                 planPeriod={(period) => setplanPeriod(period)}
//                 pricebox={true}
//               />
//             </Box>
//           )}

//           {/* Price Component */}
//           <Box sx={{ flexGrow: 1, mb: 2 }}>
//             <PriceTag
//               price_detail={price_detail}
//               planPeriod={planPeriod}
//               planName={planName}
//               planList={planList}
//               plan_mode={plan_mode}
//               bg_color={"bg-white"}
//               price_size={"48px"}
//               hide={hide}
//               plan_id={plan_id}
//               defaultPlan={defaultPlan}
//               isCurrentPlan={isCurrentPlan}
//               setCurrentPlan={setCurrentPlan}
//               setCurrentplancheck={setCurrentplancheck}
//             />
//           </Box>

//           <Divider sx={{ my: 2 }} />

//           {/* Learn More Button */}
//           <Button
//             component={Link}
//             to={{ pathname: hide ? "/homepricedetails" : "/pricedetails" }}
//             variant="outlined"
//             fullWidth
//             startIcon={<InfoIcon />}
//             sx={{
//               borderRadius: 3,
//               fontWeight: 600,
//               textTransform: "none",
//               py: 1.2,
//               borderColor: isCurrentPlan 
//                 ? theme.palette.success.main
//                 : isMostPopular
//                 ? theme.palette.warning.main
//                 : theme.palette.primary.main,
//               color: isCurrentPlan 
//                 ? theme.palette.success.main
//                 : isMostPopular
//                 ? theme.palette.warning.main
//                 : theme.palette.primary.main,
//               "&:hover": {
//                 borderWidth: 2,
//                 transform: "translateY(-2px)",
//                 transition: "all 0.3s ease"
//               }
//             }}
//           >
//             Learn More
//           </Button>
//         </CardContent>
//       </Card>
//     </Zoom>
//   );
// }

// const mapStateToProps = (state) => ({
//   currentUser: state.user.currentUser,
// });

// export default connect(mapStateToProps)(withRouter(Subscription));


import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import PriceTag from "./PricePlans/PriceTag";
import ThreeBtn from "./PricePlans/ThreeBtn";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Zoom,
  Chip,
} from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import userService from "../services/userService";

function Subscription({
  price_detail,
  planName,
  planList,
  features,
  btn_list,
  plan_mode,
  hide,
  currentUser,
  plan_id,
  defaultPlan,
  selectedPlanPeriod,
}) {
  const [planPeriod, setplanPeriod] = useState(null);
  const userDetails = useSelector((user) => user);
  const [currentPlan, setCurrentPlan] = useState();
  const [currentplancheck, setCurrentplancheck] = useState(false);

  useEffect(() => {
    if (selectedPlanPeriod) {
      setplanPeriod(selectedPlanPeriod);
    }
  }, [selectedPlanPeriod]);

  useEffect(() => {
    if (planPeriod) {
      console.log(planPeriod, "planPeriod", planName);
    }
  }, [planPeriod]);

  useEffect(() => {
    if (userDetails?.user?.currentUser?.email) {
      async function fetchPlan() {
        try {
          const email = userDetails.user.currentUser.email;
          const res = await userService.getUserProfile(email);
          const userData = res.data.user;
          setCurrentPlan(userData.plan.name);
          if (res.data.user) {
            // if you have setCurrentUser in props
          }
        } catch (err) {
          console.log("Error fetching updated plan", err);
        }
      }
      fetchPlan();
    }
  }, [currentplancheck, userDetails?.user?.currentUser?.email]);

  const isCurrentPlan =
    currentPlan === planName && !currentUser?.isAdmin && hide !== true;

  // Decide if this looks like a "popular" plan (middle plan, non-default)
  const isPopular = !defaultPlan && planList && !isCurrentPlan;

  return (
    <Zoom in={true} style={{ transitionDelay: "100ms" }}>
      <Card
        elevation={0}
        sx={{
          height: "100%",
          minHeight: { xs: "auto", md: "590px" },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          borderRadius: "22px",
          transition: "all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
          position: "relative",
          overflow: "visible",
          background: isCurrentPlan
            ? "linear-gradient(145deg, #1e3a5f 0%, #2d5986 50%, #1a3352 100%)"
            : "rgba(255,255,255,0.92)",
          backdropFilter: "blur(20px)",
          border: isCurrentPlan
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(102,126,234,0.12)",
          boxShadow: isCurrentPlan
            ? "0 20px 60px rgba(30,58,95,0.35), 0 0 0 1px rgba(255,255,255,0.08) inset"
            : "0 4px 24px rgba(102,126,234,0.08)",
          transform: isCurrentPlan ? "scale(1.01)" : "scale(1)",
          "&:hover": {
            transform: isCurrentPlan
              ? "scale(1.02) translateY(-8px)"
              : "translateY(-8px) scale(1.01)",
            boxShadow: isCurrentPlan
              ? "0 32px 80px rgba(30,58,95,0.45)"
              : "0 20px 48px rgba(102,126,234,0.18)",
          },
        }}
      >
        {/* CURRENT badge */}
        {isCurrentPlan && (
          <Box
            sx={{
              position: "absolute",
              top: -14,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
            }}
          >
            <Chip
              icon={<StarRoundedIcon sx={{ fontSize: "16px !important", color: "#fff !important" }} />}
              label="CURRENT PLAN"
              sx={{
                px: 1,
                py: 2,
                fontWeight: 800,
                fontSize: "11px",
                letterSpacing: "1px",
                background: "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",
                color: "#1a1a2e",
                border: "none",
                boxShadow: "0 4px 16px rgba(247,151,30,0.4)",
                "& .MuiChip-icon": { color: "#1a1a2e !important" },
              }}
            />
          </Box>
        )}

        <CardContent
          sx={{
            p: { xs: 3, md: 2.25, lg: 2.5 },
            display: "flex",
            flexDirection: "column",
            height: "100%",
            "&:last-child": { pb: { xs: 3, md: 2.25, lg: 2.5 } },
          }}
        >
          {/* Plan Name */}
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              fontWeight: 800,
              mb: 0.5,
              mt: isCurrentPlan ? 1 : 0,
              fontSize: { xs: "20px", md: "18px", lg: "20px" },
              letterSpacing: "-0.3px",
              color: isCurrentPlan ? "#ffffff" : "#1a1a2e",
            }}
          >
            {planName}
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "12px",
              lineHeight: 1.35,
              color: isCurrentPlan ? "rgba(255,255,255,0.72)" : "#64748b",
              mb: 1.5,
              minHeight: "32px",
            }}
          >
            {defaultPlan
              ? "Perfect for getting started"
              : isCurrentPlan
              ? "Best for professionals"
              : planName?.toLowerCase().includes("enterprise")
              ? "For large organizations"
              : "For teams and businesses"}
          </Typography>

          {/* Subtle divider */}
          <Box
            sx={{
              width: "40px",
              height: "3px",
              borderRadius: "2px",
              background: isCurrentPlan
                ? "rgba(255,255,255,0.3)"
                : "linear-gradient(90deg, #667eea, #764ba2)",
              mx: "auto",
              mb: 2,
            }}
          />

          {/* Period Selector */}
          {!defaultPlan && !selectedPlanPeriod && (
            <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
              <ThreeBtn
                btn_list={btn_list}
                planPeriod={(period) => setplanPeriod(period)}
                pricebox={true}
              />
            </Box>
          )}

          {/* Price Tag */}
          <Box sx={{ flexGrow: 1, minHeight: 0 }}>
            <PriceTag
              price_detail={price_detail}
              planPeriod={selectedPlanPeriod || planPeriod}
              planName={planName}
              planList={planList}
              features={features}
              plan_mode={plan_mode}
              bg_color={"bg-white"}
              price_size={"44px"}
              hide={hide}
              plan_id={plan_id}
              defaultPlan={defaultPlan}
              isCurrentPlan={isCurrentPlan}
              setCurrentPlan={setCurrentPlan}
              setCurrentplancheck={setCurrentplancheck}
            />
          </Box>
        </CardContent>
      </Card>
    </Zoom>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(mapStateToProps)(withRouter(Subscription));
